import React from 'react';
import styled from 'styled-components';
import logoSVG from '../data/images/AAM-logo-notext.svg';
import { calc4k } from '../utilities';
import { gradient, padding } from '../GlobalStyle';
import Alert from './Alert';

export default function({ title, position, bgBlack, alertActive, alertMessage, alertOnly, alertSpeed }) {
    return (
        <HeaderWrap position={position}>
            <Alert active={alertActive} message={alertMessage} speed={alertSpeed}/>
            {
                !alertOnly ? (
                    <Header bgBlack={bgBlack}>
                        <Title>{title}</Title>
                        <Logo src={logoSVG} />
                    </Header>
                ) : null
            }
        </HeaderWrap>
    );
}

const HeaderWrap = styled.div`
    position: ${p => p.position || 'absolute'};
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1;
`;

const Header = styled.header`
    padding: ${calc4k(80)} ${padding.side};
    background-image: ${gradient.black};
    background-color: ${p => (p.bgBlack ? '#000' : 'transparent')};
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    z-index: 1;
`;

const Title = styled.h1`
    font-size: ${calc4k(80)};
`;

const Logo = styled.img`
    height: ${calc4k(118)};
    width: auto;
`;